// @ts-nocheck
import { CONTACT_ADMIN_ERROR, CONTACT_ADMIN_LOADING, CONTACT_ADMIN_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const ContactAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONTACT_ADMIN_LOADING:
            return Object.assign({}, state, { loading: true })
        case CONTACT_ADMIN_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CONTACT_ADMIN_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

